import {Data} from "./TableInterfaces";

export interface ProductType extends Data {
  name: string
}

export const PRODUCT_TYPE_INITIAL_VALUES: ProductType = {
  name: "",
}
